import { IonContent } from '@ionic/react';
import React from 'react';

import { webCampaign } from '@/modules/webCampaign';

import { Content } from './components/Content';
import { Title } from './components/Title';
import { PageStyles } from './Devmode.styles';

const DevmodeVariant: React.FC = () => {
  return (
    <PageStyles background={webCampaign.getStaticTheme()}>
      <IonContent>
        <Title />

        <Content />
      </IonContent>
    </PageStyles>
  );
};

export default DevmodeVariant;
